import { useCallback, useEffect } from 'react'
import { useAuditScanProgress } from '../context/AuditScanProgressContext'

export const useRefetchCallback = (
  mutate: () => void,
  componentId: string,
): void => {
  const { registerRefetchCallback } = useAuditScanProgress()

  // Create a stable callback that won't change between renders
  const refetchCallback = useCallback(() => {
    mutate()
  }, [mutate])

  // Register the callback once when component mounts
  useEffect(() => {
    const cleanup = registerRefetchCallback(refetchCallback, componentId)
    return cleanup
  }, [registerRefetchCallback, refetchCallback, componentId])
}
